import http from './http';

const ENDPOINTS = {
  OPINIONS: '/api/v1/opinions',
  OPINION_BY_ID: (id) => `/api/v1/opinions/${id}`,
};

/**
 * Doctor Opinions API Service
 */
export const opinionsAPI = {
  // Create a new doctor opinion
  create: async (opinionData) => {
    const response = await http.post(ENDPOINTS.OPINIONS, opinionData);
    return response.data;
  },

  // Get opinion by ID
  getById: async (id) => {
    const response = await http.get(ENDPOINTS.OPINION_BY_ID(id));
    return response.data;
  },

  // Update opinion
  update: async (id, opinionData) => {
    const response = await http.patch(ENDPOINTS.OPINION_BY_ID(id), opinionData);
    return response.data;
  },

  // List opinions with filtering
  list: async (params = {}) => {
    const response = await http.get(ENDPOINTS.OPINIONS, { params });
    return response.data;
  },

  // Search opinions by patient or doctor
  search: async (params = {}) => {
    const response = await http.get(ENDPOINTS.OPINIONS, { params });
    return response.data;
  },

  // Delete opinion
  delete: async (id) => {
    const response = await http.delete(ENDPOINTS.OPINION_BY_ID(id));
    return response.data;
  }
};

export default opinionsAPI;